import { BaseEntity } from './base-entity';
import { Contact } from './contact';

export class AssessmentTarget extends BaseEntity {
  contacts: Array<Contact>;
}
